import config from 'constants/config'
import themes from 'constants/themes'
import React, { PropsWithChildren } from 'react'
import { ThemeProvider } from 'styled-components'

let inverseTheme: App.Theme

type Props = PropsWithChildren<{
  type: 'default' | 'inverse'
}>

export default function PaletteProvider({ type, children }: Props) {
  const defaultTheme = themes[config.BRAND]
  let providedTheme = defaultTheme

  if (type === 'inverse') {
    providedTheme = inverseTheme
    if (!providedTheme) {
      // substitue the inverse palette for the base palette
      // this will make all children now use the inverse palette
      providedTheme = {
        ...defaultTheme,
        palette: defaultTheme.inversePalette,
        inversePalette: defaultTheme.palette,
      }
      inverseTheme = providedTheme
    }
  }

  return <ThemeProvider theme={providedTheme}>
    {children}
  </ThemeProvider>
}
